<template>
  <div style="margin-top: 20px">
    <el-form :model="formData" :rules="formRules" ref="formRef" size="mini" label-width="80px" style="text-align: left">
      <el-form-item label="上级">
        <el-cascader v-model="formData.pid" :options="topPerms" :props="{ value: 'id', label: 'name', checkStrictly: true }" placeholder="一级目录" clearable style="width: 320px"></el-cascader>
      </el-form-item>
      <el-form-item label="名称" prop="name" :error="errMsg.name">
        <el-input v-model="formData.name" style="width: 320px"> </el-input>
      </el-form-item>
      <el-form-item label="路径" prop="path" :error="errMsg.path">
        <el-input v-model="formData.path" style="width: 320px"> </el-input>
      </el-form-item>
      <el-form-item label="菜单">
        <el-cascader v-model="formData.menu_id" :options="topMenu" :props="{ value: 'id', label: 'name', checkStrictly: true }" @change="routeChange" clearable style="width: 320px"></el-cascader>
      </el-form-item>
      <el-form-item label="标记">
        <el-input v-model="formData.mark" style="width: 320px"> </el-input>
      </el-form-item>
    </el-form>
    <div class="form-but">
      <el-button type="success" @click="permSave">保存</el-button>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
export default {
  name: 'authPermSave',
  created() {
    this.getMenu()
  },
  data() {
    return {
      topMenu: [],
      topPerms: [],
      errMsg: {},
      formData: { id: 0, pid: 0, menu_id: 0, name: '', path: '', mark: '' },
      // 表单验证规则
      formRules: {
        name: [{ required: true, message: '请输权限名称', trigger: 'blur' }],
        path: [{ required: true, message: '请输入path', trigger: 'blur' }]
      }
    }
  },
  methods: {
    routeChange(e) {
      if (e != undefined) {
        this.formData.menu_id = e.slice(-1)[0]
      }
    },
    rest() {
      this.formData = { id: 0, pid: 0, menu_id: 0, name: '', path: '', mark: '' }
    },
    //获取菜单
    async getMenu() {
      await this.$api.auth.menuList().then(res => {
        if (res.code != 200) return
        this.topMenu = res.data ? res.data : []
      })
    },
    //保存
    async permSave() {
      this.$refs.formRef.validate(async vaild => {
        if (vaild) {
          this.initErrMsg()
          let perms = _.cloneDeep(this.formData)
          if (Array.isArray(perms.pid)) {
            perms.pid = perms.pid[perms.pid.length - 1]
          }
          console.log(perms, this.formData)
          await this.$api.auth.permSave(perms).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg)
              if (this.formData.id == 0) {
                this.rest()
              }
              this.$emit('callMethod')
            } else {
              for (let k in res.data) {
                this.errMsg[k] = res.data[k]
              }
            }
          })
        }
      })
    },
    //初始化错误信息对象
    initErrMsg() {
      this.errMsg = {}
      this.$refs.formRef.fields.map(i => {
        this.$set(this.errMsg, i.prop, '')
      })
    },
    //父页面传数据
    setData(topPerms, data) {
      if (topPerms.length > 0) {
        this.topPerms = Object.assign([], topPerms)
      }
      if (data == undefined) {
        this.rest()
      } else {
        this.formData = data
      }
      this.initErrMsg()
    }
  }
}
</script>
